import courtOfJusticeFA from './fa/fa.json'

const courtOfJusticeMessages = {
  fa: { ...courtOfJusticeFA },
}

export default courtOfJusticeMessages
